export const microServicesEnum = Object.freeze({
  SOCKET: 'SOCKET',
  BACKEND: 'BACKEND'
})

export const userRolesEnum = {
  OWNER: 'OWNER',
  STAFF: 'STAFF',
  WRITER: 'WRITER',
  READER: 'READER',
  ORG_ADMIN: 'ORG_ADMIN',
  SUPERVISOR: 'SUPERVISOR',
  SUPER_ADMIN: 'SUPER_ADMIN'
}

export const teamMembersStatusEnum = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  INVITATION_PENDING: 'INVITATION_PENDING'
}

export const paymentMethodEnum = {
  NMI: 'NMI',
  STRIPE: 'STRIPE',
  PAYPAL: 'PAYPAL',
  WALLET: 'WALLET'
}

export const paypalResponseStatusEnum = Object.freeze({
  cancel: 'cancel',
  success: 'success'
})

export const paypalActionsEnum = Object.freeze({
  PAY_INVOICE: 'PAY_INVOICE',
  RECHARGE_WALLET: 'RECHARGE_WALLET'
})

export const publicPromptTypesEnum = Object.freeze({
  COMPOSE: 'COMPOSE',
  REWRITE: 'REWRITE'
})

export const languagesEnum = Object.freeze({
  PT: 'PT',
  SPANISH: 'SPANISH',
  ENGLISH: 'ENGLISH'
})

export const languagesFilterEnum = Object.freeze({
  PT: 'pt',
  SPANISH: 'es',
  ENGLISH: 'en'
})

export const articleStatusEnum = Object.freeze({
  PUBLISH: 'PUBLISH',
  PENDING: 'PENDING'
})

export const invoiceItemCodenameEnum = Object.freeze({
  GP_PACKAGE: 'GP_PACKAGE',
  GP_POSTPRICE: 'GP_POSTPRICE'
})

export const invoiceStatusEnum = {
  PAID: 'PAID',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  NOT_PAID: 'NOT_PAID',
  REFUNDED: 'REFUNDED',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  REFUND_CONFLICT: 'REFUND_CONFLICT',
  PAYMENT_CONFLICT: 'PAYMENT_CONFLICT',
  REFUND_REQUESTED: 'REFUND_REQUESTED'
}

export const modelCodenameEnum = Object.freeze({
  GUESTPOSTING: 'GUESTPOSTING'
})

export const guestPostingStatusEnum = {
  DRAFT: 'DRAFT',
  DELETED: 'DELETED',
  PUBLISHED: 'PUBLISHED',
  COMPOSING: 'COMPOSING',
  PUBLISHING: 'PUBLISHING',
  UNPUBLISHING: 'UNPUBLISHING',
  COMPOSING_FAIL: 'COMPOSING_FAIL',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PUBLISH_FAILED: 'PUBLISH_FAILED'
}

export const spySerpStatusEnum = {
  DONE: 'DONE',
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS'
}

export const guestPostingStatisticsEnum = Object.freeze({
  CAMPAINGS_DISTRIBUTION: 'CAMPAINGS_DISTRIBUTION',
  CATEGORIES_DISTRIBUTION: 'CATEGORIES_DISTRIBUTION',
  DOMAIN_RANK_DISTRIBUTION: 'DOMAIN_RANK_DISTRIBUTION',
  NUMBER_OF_PUBLISHED_POSTS: 'NUMBER_OF_PUBLISHED_POSTS'
})

export const styleArticleEnum = Object.freeze({
  BLOG: 'BLOG',
  FORMAL: 'FORMAL',
  NATURAL: 'NATURAL',
  NEWSCAST: 'NEWSCAST',
  INFORMAL: 'INFORMAL'
})

export const countriesEnum = Object.freeze({
  USA: 'USA',
  PERU: 'PERU',
  CHILE: 'CHILE',
  SPAIN: 'SPAIN',
  MEXICO: 'MEXICO',
  BRAZIL: 'BRAZIL',
  CANADA: 'CANADA',
  PANAMA: 'PANAMA',
  ECUADOR: 'ECUADOR',
  BOLIVIA: 'BOLIVIA',
  URUGUAY: 'URUGUAY',
  COLOMBIA: 'COLOMBIA',
  PARAGUAY: 'PARAGUAY',
  PORTUGAL: 'PORTUGAL',
  HONDURAS: 'HONDURAS',
  VENEZUELA: 'VENEZUELA',
  GUATEMALA: 'GUATEMALA',
  NICARAGUA: 'NICARAGUA',
  ARGENTINA: 'ARGENTINA',
  COSTA_RICA: 'COSTA_RICA',
  DOMINICANA: 'DOMINICANA',
  EL_SALVADOR: 'EL_SALVADOR',
  PUERTO_RICO: 'PUERTO_RICO'
})

export const domainRankEnum = Object.freeze({
  MORE_40: 'MORE_40',
  FROM_0_20: 'FROM_0_20',
  FROM_30_40: 'FROM_30_40',
  FROM_20_30: 'FROM_20_30'
})

export const typeMovementEnum = Object.freeze({
  RECHARGE: 'RECHARGE',
  GUESTPOSTING: 'GUESTPOSTING'
})

export const copyrightImageSourceEnum = {
  MADE_BY_ME: 'MADE_BY_ME',
  GOOGLE_IMAGES: 'GOOGLE_IMAGES',
  FREE_IMAGE_BANK: 'FREE_IMAGE_BANK',
  PAID_IMAGE_BANK: 'PAID_IMAGE_BANK',
  SOCIAL_NETWORKS: 'SOCIAL_NETWORKS',
  MADE_BY_A_PROFESSIONAL: 'MADE_BY_A_PROFESSIONAL',
  AI_GENERATED: 'AI_GENERATED'
}

/** Visual styles the AI image generator offers (backend AiImageStyle). */
export const aiImageStyleEnum = Object.freeze({
  PHOTO: 'PHOTO',
  ILLUSTRATION: 'ILLUSTRATION',
  MINIMAL: 'MINIMAL'
})

export const guestPostingPublicationStepsEnum = {
  RESULTS: 'RESULTS',
  REVISION: 'REVISION',
  REDACTION: 'REDACTION',
  GENERATION: 'GENERATION',
  COMBINATION: 'COMBINATION',
  QUICK_CAMPAIGN: 'QUICK_CAMPAIGN',
  PUBLICATION_PAYMENTS: 'PUBLICATION_PAYMENTS'
}

export const guestPostingDuplicationModeEnum = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  TO_NORMAL_CAMPAIGN: 'TO_NORMAL_CAMPAIGN',
  TO_NORMAL_CAMPAIGN_WITH_SITES: 'TO_NORMAL_CAMPAIGN_WITH_SITES'
}

export const paymentStatusEnum = {
  PAID: 'PAID',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  REFUNDED: 'REFUNDED',
  CANCELLED: 'CANCELLED',
  REFUND_CONFLICT: 'REFUND_CONFLICT',
  REFUND_REQUESTED: 'REFUND_REQUESTED'
}

export const publicPromptEnum = Object.freeze({
  SIMPLIFY: 'SIMPLIFY',
  SUMMARIZE: 'SUMMARIZE',
  TAKEAWAYS: 'TAKEAWAYS',
  MAKE_LONGER: 'MAKE_LONGER',
  FIX_SPELLING: 'FIX_SPELLING',
  MAKE_SHORTER: 'MAKE_SHORTER',
  IMPROVE_WRITING: 'IMPROVE_WRITING',
  CHANGE_TONE_CONFIDENT: 'CHANGE_TONE_CONFIDENT',
  CHANGE_TONE_PROFESSIONAL: 'CHANGE_TONE_PROFESSIONAL'
})
